import { defaultLocale } from '../../settings';

export const setDefaultLanguage = (language) => {
  if (!localStorage.getItem('i18nextLng' && language)) {
    localStorage.setItem('i18nextLng', language);
  }
};

const getDetectedLocale = () => localStorage.getItem('i18nextLng').toUpperCase();

export const getInternationalizedResource = resourceKey => `${resourceKey}_${getDetectedLocale()}`;
export const getDefaultLanguageResource = resourceKey => `${resourceKey}_${defaultLocale.toUpperCase()}`;

export const translateFallback = (t, defaultKey, fallbackFn) => {
  const translation = t(defaultKey);
  if (translation === defaultKey) {
    return fallbackFn();
  }
  return translation;
};

export function changeFavicon(url) {
  const link = document.querySelector('link[rel*=\'icon\']') || document.createElement('link');
  link.type = 'image/x-icon';
  link.rel = 'shortcut icon';
  link.href = url;
  document.getElementsByTagName('head')[0].appendChild(link);
}

export const resolveDataProtectionLink = (frontendCustomisationConfig, languageCode) => {
  const legacyLink = frontendCustomisationConfig?.oepmDataProtectionLink;
  const localizedLinks = frontendCustomisationConfig?.oepmDataProtectionLinks;

  if (!localizedLinks || typeof localizedLinks !== 'object' || Array.isArray(localizedLinks)) {
    return legacyLink;
  }

  if (languageCode && typeof languageCode === 'string') {
    if (localizedLinks[languageCode]) {
      return localizedLinks[languageCode];
    }

    const baseLanguage = languageCode.split('-')[0];
    if (baseLanguage && localizedLinks[baseLanguage]) {
      return localizedLinks[baseLanguage];
    }
  }

  return localizedLinks.default || legacyLink;
};
